<script lang="ts" context="module">
    export const topNavigatorOpen = writable(false)
</script>

<script lang="ts">
    import { headerAnimationOpen } from "@components/TopBar/TopBar.svelte"
    import TopNavigator from "@components/topNavigator/TopNavigator.svelte"
    import { slide } from "svelte/transition"
    import { currentPageOrRenderItemPath, selectedTab } from "@store/pageTracker"
    import { slip, type Renderable, isRenderable } from "@circleofa/acim-engine"
    import { acim } from "@utils/acim"
    import TopBarTabs from "./TopBarTabs.svelte"
    import { writable } from "svelte/store"
    import type { Navigable } from "@circleofa/acim-engine"

    let childPage: Renderable | null = null
    $: try {
        if ($selectedTab) {
            childPage = slip(acim.findRenderableOrSlippable($selectedTab.path))
        } else {
            childPage = slip(acim.findRenderableOrSlippable($currentPageOrRenderItemPath))
        }
    } catch (e) {
        childPage = null
    }
</script>

{#if $topNavigatorOpen}
    <div
        class="tabsNavContainer"
        transition:slide|global
        on:outroend={() => ($headerAnimationOpen = false)}
        on:introend={() => ($headerAnimationOpen = true)}
    >
        <div class="tabsNav">
            <div class="headerTabList">
                <TopBarTabs />
            </div>
            <div>
                {#if childPage}
                    <TopNavigator page={childPage} />
                {/if}
            </div>
        </div>
    </div>
{/if}

<style>
.tabsNavContainer {
  will-change: opacity, height, padding-top, padding-bottom, margin-top, margin-bottom, border-top-width, border-bottom-width, position;
  top: 0;
  overflow: visible !important;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.tabsNav {
  display: grid;
  font-stretch: condensed;
  grid-template-rows: repeat(2, max-content);
  grid-template-columns: 100%;
  width: 100%;
}
</style>
